import React from "react";
import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
// import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import AllServiceRegions from "../components/AllServiceRegions";


const AllServiceRegionsPage = () => {
  return (
    <> 
    <div>
        
      <HeroSlider />
      <AllServiceRegions/>
      <ServicesGrid />
      <BlogList/>
      
      <Footer/>
     
    </div>
     </>
  );
};

export default AllServiceRegionsPage;
